import React from 'react';

const Heading = ({ children, size = 'lg', weight = 'bold', className = '' }) => {
  const sizeClasses = {
    xl: 'text-3xl md:text-4xl',
    lg: 'text-2xl md:text-3xl',
    md: 'text-xl md:text-2xl'
  };
  
  const weightClasses = {
    bold: 'font-bold',
    semibold: 'font-semibold'
  };
  
  return (
    <h2 className={`text-[#0C1D40] ${sizeClasses[size]} ${weightClasses[weight]} ${className}`}>
      {children}
    </h2>
  );
};

export default Heading;